"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.UI = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var Loader = __importStar(require("./loader"));
var buttons_group_1 = __importDefault(require("./buttons-group"));
var StatusUI = function (_a) {
    var id = _a.id, updatePromise = _a.updatePromise, options = _a.options, selectedId = _a.selectedId;
    var _b = react_1["default"].useState(selectedId), sid = _b[0], setSelectedId = _b[1];
    var _c = react_1["default"].useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var enqueueSnackbar = __1.Utils.useSnackbar().enqueueSnackbar;
    var handleClick = function (optionId) {
        setIsLoading(true);
        updatePromise(id, optionId)
            .then(function (_) {
            setSelectedId(optionId);
            setIsLoading(false);
        })["catch"](function (err) {
            setIsLoading(false);
            if (err.message) {
                __1.Utils.confirmMessage(enqueueSnackbar, err.message, 'error');
            }
        });
    };
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(buttons_group_1["default"], { options: options, selectedId: sid, onClick: handleClick }),
        react_1["default"].createElement(Loader.Loader, { isLoading: isLoading })));
};
exports.UI = function (_a) {
    var data = _a.data, updatePromise = _a.updatePromise;
    var options = data.options, selectedId = data.selectedId, id = data.id;
    return (react_1["default"].createElement(StatusUI, { id: id, options: options, selectedId: selectedId, updatePromise: updatePromise }));
};
